/**
 * Shared Core — Error Definitions
 */

export type FlightPlanErrorCode =
  | 'INVALID_IDENTIFIER'
  | 'ROUTE_NOT_FOUND'
  | 'AIRSPACE_BLOCKED'
  | 'ALTITUDE_INVALID'
  | 'DATABASE_ERROR'
  | 'NETWORK_ERROR'
  | 'FILING_ERROR'
  | 'FILING_AUTH_ERROR'
  | 'PARSE_ERROR'
  | 'EXPORT_ERROR'
  | 'AI_PARSE_FAILED'
  | 'AIRCRAFT_PROFILE_NOT_FOUND'
  | 'FUEL_INSUFFICIENT'
  | 'TERRAIN_CLEARANCE_FAILED';

export class FlightPlanError extends Error {
  constructor(
    message: string,
    public readonly code: FlightPlanErrorCode,
    public readonly details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'FlightPlanError';
  }
}
